<template>
  <div>
    <bread-crumb2 :menu="{name: '파트너별 상품 상세 현황',
    desc: '상품에 파트너가 복수로 지정된 경우 파트너별로 재고 및 주문 현황을 확인할 수 있습니다.'}"></bread-crumb2>
    <!-- 상품 정보 -->
    <div class="box" v-if="product">
      <admin-box-item title="상품 정보">
        <table class="table">
          <thead>
          <tr>
            <th>상품ID</th>
            <th>상품등록일</th>
            <th>노출여부</th>
            <th>카테고리</th>
            <th>대표이미지</th>
            <th>상품명</th>
            <th>판매가</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <th>{{ product.id }}</th>
            <th>{{ product.created_time }}</th>
            <th>{{ product.enable_prod ? '노출함':'노출안함' }}</th>
            <th>{{ product.category.replaceAll('>','\n > ') }}</th>
            <th>
              <div :style="thumbImgField(product.first_img)" v-if="product.first_img"></div>
            </th>
            <th>{{ product.name }}</th>
            <th>{{ product.price | currency }}</th>
          </tr>
          </tbody>
        </table>
      </admin-box-item>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="600"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <div slot="stock" slot-scope="props">
        <div v-if="props.item.enable_option">
          <div v-for="(stock, stock_idx) in props.item.stocks" :key="`stock-${stock_idx}`" class="flex-align">
            <div style="width:50%;text-align: right;padding-right: 6px">{{ stock.name }}</div>
            <div class="unselect" style="text-decoration: underline;width:50%;text-align:left;padding-left:6px" @click="openSelectorStockModal(props.item)">
              {{ stock.enable_stock ? `${stock.stock}개`:'무한대' }}</div>
          </div>
        </div>
        <div v-else>
          <div class="unselect" style="text-decoration: underline" @click="openStockModal(props.item)">
            {{ props.item.stock_type===1 ? '무한대':`${props.item.stock}개` }}</div>
        </div>
      </div>

      <div slot="ordered_count" slot-scope="props">
        <div v-if="props.item.enable_option">
          <div v-for="(stock, stock_idx) in props.item.stocks" :key="`stock-${stock_idx}`" class="flex-align">
            <div style="width:50%;text-align: right;padding-right: 6px">{{ stock.name }}</div>
            <div style="width:50%;text-align:left;padding-left:6px">{{ stock.order_count }}개</div>
          </div>
        </div>
        <div v-else>{{ props.item.ordered_count }}개</div>
      </div>
    </admin-table>

    <!-- 상품 재고 팝업 -->
    <modal name="StockModal"
           :adaptive="true"
           :width="600"
           height="auto"
           class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 재고 수정" v-if="selectedProduct">
          <div class="columns is-multiline">
            <!-- 재고 사용여부 -->
            <div class="column is-full">
              <admin-form-item label="재고 사용여부">
                <lp-radio :val.sync="selectedProduct.stock_type"
                          value_name="value"
                          label_name="label"
                          @onSelect="res => selectedProduct.stock_type=res"
                          :data="[{label:'사용',value:0},{label:'무한대',value:1}]"></lp-radio>
              </admin-form-item>
            </div>
            <!-- 재고 사용 -->
            <div v-if="selectedProduct.stock_type===0">
              <!-- 입고 수량 -->
              <div class="column is-full flex-align">
                <admin-form-item label="입고">
                  <div style="display:flex;align-items: center">
                    <input class="input product-short-input"
                           v-model="addCount"
                           @keyup.enter="addStock"
                           type="number">
                    <button class="button is-primary"
                            style="margin-left:8px;width:48px"
                            @click="addStock">추가</button>
                  </div>
                </admin-form-item>
              </div>
              <!-- 주문 수량 -->
              <div class="column is-full">
                <admin-form-item label="주문 수량"
                                 justifyContent="space-between"
                                 :isFlex="true">{{ selectedProduct.ordered_count }}개
                </admin-form-item>
              </div>
              <!-- 재고 수량 -->
              <div class="column is-full">
                <admin-form-item label="재고 수량"
                                 justifyContent="space-between"
                                 desc="재고 수량이 0개 인 경우에는 자동 '품절'처리 됩니다."
                                 :isHeaderBlock="true"
                                 :isFlex="true">{{selectedProduct.stock}}개</admin-form-item>
              </div>
            </div>
          </div>
          <div class="confirm-stock">
            <button class="button is-primary" @click="saveStock">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <!-- 상품 옵션 재고 팝업 -->
    <modal name="SelectorStockModal"
           :adaptive="true"
           :width="600"
           height="auto"
           class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 재고 수정" subtitle="재고 수량이 0인 경우에는 자동 '품절' 처리 됩니다.">
          <div style="overflow-y: scroll;height:70vh;padding-bottom:60px">
            <lp-prod-option-stocks :selectors="selectedSelectorStock"
                                   :requiredOptionStockUsing="false"
                                   :order_conversion_type="12"
                                   v-if="selectedSelectorStock"></lp-prod-option-stocks>
          </div>
          <div class="confirm-selector-stock">
            <button class="button is-primary" @click="saveSelectorStock">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import BreadCrumb2 from "../../module/common/BreadCrumb2";
  import LpProdOptionStocks from "../../module/common/LpProdOptionStocks";
  import {SweetModal} from 'sweet-modal-vue'
  import LpRadio from "../../module/common/LpRadio";

  export default {
    name: "MartPartnerProductDetail",
    components: {LpRadio, LpProdOptionStocks, BreadCrumb2, SweetModal},
    mixins: [
      ListMixin
    ],
    data() {
      return {
        product: undefined,
        selectedSelectorStock: undefined,
        selectedProduct: undefined,
        addCount: 0,
        stockCount: 0
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        this.initializing('mart_product', `mart/product/${this.$route.query.id}/partner`);
        this.getProduct();
      },
      getDataFromServer() {
        this.getData();
      },
      getProduct() {
        let url = this.getUrl(`mart/product/${this.$route.query.id}`);
        this.$axios.get(url).then(res => {
          this.product = res.data;
        })
      },
      // 상품 재고
      openStockModal(item) {
        this.selectedProduct = this.cloneItem(item);
        this.$modal.show('StockModal')
      },
      // 상품 옵션 재고
      openSelectorStockModal(item) {
        this.selectedProduct = this.cloneItem(item);
        let stocks = this.cloneItem(item.stocks)
        for (let i=0; i<stocks.length; i++) {
          stocks[i].addCount = 0;
          stocks[i].add = 0;
          stocks[i].stockCount = stocks[i].stock;
        }
        this.selectedSelectorStock = stocks;
        this.$modal.show('SelectorStockModal')
      },
      // 입고수량 재고 수량에 추가하기
      addStock() {
        this.selectedProduct.add = parseInt(this.selectedProduct.add ? this.selectedProduct.add : 0) + parseInt(this.addCount);
        if(this.stockCount === 0) {
          this.stockCount = this.selectedProduct.stock;
        }
        this.selectedProduct.stock = this.stockCount + this.selectedProduct.add;
        this.addCount = 0;
      },
      // 상품 재고 저장
      saveStock() {
        let url = `product/${this.selectedProduct.id}/stock/update`;
        this.$axios.patch(this.getUrl(url), {
          stock: this.selectedProduct.stock,
          stock_type: this.selectedProduct.stock_type

        }).then(res => {
          if(res.status===200) {
            this.toast('수정되었습니다.')
            this.$modal.hide('StockModal');
            this.getDataFromServer();
          }
        })
      },
      // 상품 옵션 재고 저장
      saveSelectorStock () {
        let url = `product/${this.selectedProduct.id}/selector_stocks/update`;
        this.$axios.patch(this.getUrl(url), {
          selectorStocks: this.selectedSelectorStock
        }).then(res => {
          if(res.status===200) {
            this.toast('수정되었습니다.')
            this.$modal.hide('SelectorStockModal');
            this.getDataFromServer();
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  td, th
    font-weight 400

  .confirm-stock
    width 100%
    display flex
    justify-content flex-end
    padding 12px 0
    background-color white

  .confirm-selector-stock
    position absolute
    bottom 0
    left 0
    width 100%
    display flex
    justify-content flex-end
    padding 12px 0
    background-color white
</style>
